import type {QuestionChoice} from '../types'

export const toPollRequestBodyAuth = (deliveryId: string, answersChoices: QuestionChoice[]) => ({
  delivery_id: deliveryId,
  answers_choices: answersChoices,
})
